// extracted by mini-css-extract-plugin
export default {"select":"JMWvzC3EIUNzgQi6W1Kz","dropdown":"gO8PO_wW_Zj02mm6MzoC","callout":"CMZJQTrWwwRnVuMF7QZW"};